import { render, staticRenderFns } from "./banner_center.vue?vue&type=template&id=3f6f306f&scoped=true"
import script from "./banner_center.vue?vue&type=script&lang=js"
export * from "./banner_center.vue?vue&type=script&lang=js"
import style0 from "./banner_center.vue?vue&type=style&index=0&id=3f6f306f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6f306f",
  null
  
)

export default component.exports